import { AccountingProvider } from '@neo.tax/shared/graphql';

import { ConnectProvider } from './ConnectProvider';
import { useSyncAccountingProvider } from './hooks';

interface ConnectAccountingProps {
  providerName: AccountingProvider;
  close: () => void;
  restart: () => void;
  fiscalYearId: string;
}

export const ConnectAccounting = ({
  close,
  fiscalYearId,
  providerName,
  restart,
}: ConnectAccountingProps): React.ReactElement => {
  const { connect, connectStatus } = useSyncAccountingProvider({ fiscalYearId, providerName });
  return (
    <ConnectProvider
      connect={connect}
      close={close}
      restart={restart}
      connectStatus={connectStatus}
      provider={{ providerName, providerType: 'accounting' }}
    />
  );
};
